<template>
  <div class="home">
    <div class="header">

<!--      <div class="titleBox position0" :class="activeNum==1?'active':''" @click="changePage(1)">物联中心</div>
      <div class="titleBox position1" :class="activeNum==2?'active':''" @click="changePage(2)">环境监测</div>
      <div class="titleBox position2" :class="activeNum==3?'active':''" @click="changePage(3)">养殖管理</div>
      <div class="titleBox position3" :class="activeNum==4?'active':''" @click="changePage(4)">溯源中心</div>
      <div class="titleBox position4" :class="activeNum==5?'active':''" @click="changePage(5)">视频中心</div>
      <div class="titleBox position5" :class="activeNum==6?'active':''" @click="changePage(6)">监测中心</div>-->



      <div>
        <div class="titleBox"
             v-for="(item, index) in showList"
             :class="[activeNum==item.id?'active':'', `position${index}`]"
             @click="changePage(item)"
        >
          {{item.name}}
        </div>
      </div>

      <div class="tcHoutai" @click="goHouTai"></div>
      <div class="tclogin" @click="logout"></div>

      <div class="left icon" @click="onLeft"></div>
      <div class="right icon" @click="onRight"></div>
    </div>

    <div class="content"><router-view /></div>
    <div class="footer"></div>
  </div>
</template>
<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      activeNum:1,
      index: 0,
      headerList:[
        {
          id:1,
          name:'养殖园区',
          page: 'BreedingPark',
        },
        {
          id: 2,
          name:'物联中心',
          page: 'oTCenter'
        },
        {
          id:3,
          name:'环境监测',
          page: 'environmentalMonitoring'
        },
        {
          id:4,
          name:'养殖管理',
          page: 'breedingManagement'
        },
        // {
        //   id:5,
        //   name:'溯源中心',
        //   page: 'TraceabilityCenter'
        // },
        {
          id:6,
          name:'视频中心',
          page: 'videoCenter'
        },
        {
          id:7,
          name:'监测中心',
          page: 'MonitoringCenter'
        },
        {
          id:8,
          name:'防疫中心',
          page: 'EpidemicPrevention'
        },
        {
          id:9,
          name:'在线交易',
          page: 'OnlineTrading'
        },
        {
          id:5,
          name:'溯源中心',
          page: 'TraceabilityCenter'
        },
      ],
    };
  },
  computed: {
    showList(){
      const arr = JSON.parse(JSON.stringify(this.headerList));
      return arr.splice(this.index, 6);
    }
  },
  created(){

  },
  watch: {
    '$route': (val) => {
      console.log('$route', val.name)
    }
  },
  mounted() {
    let num = localStorage.getItem('activeNum')

    this.activeNum = num || 1;

    window.addEventListener(
      "hashchange",
      () => {
        console.log("当前路由页面", window.location.hash);
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
  methods: {
    // 点击左边
    onLeft(){
      this.index--;
      if (this.index < 0) {
        this.index = 0;
      }
    },
    // 点击右边
    onRight(){
      this.index++;
      const max = this.headerList.length - 6;
      console.log(max)
      if (this.index > max){
        this.index = max;
      }
    },
    // 退出登录
    logout() {
      // 清除存储在 localStorage 中的 token
      localStorage.removeItem("token");

      // 如果你的应用使用了 Vuex，重置相关的用户状态
      // this.$store.commit('RESET_USER_STATE');

      // 重定向到登录页或首页
      this.$router.push("/login"); // 或 this.$router.push('/');

      // 可选：显示注销成功的消息
      // this.$message.success('您已成功注销');
    },
    goHouTai(){
      // this.$router.push("/systemMenu");
      this.$router.push("/choker");
    },
    changePage(row) {
      this.activeNum=row.id
      localStorage.setItem('activeNum',row.id)
      this.$router.push({ name: row.page });

    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .header {
    height: 18px;
    width: 100%;
    background-image: linear-gradient(rgba(12, 22, 24, 1), rgba(12, 22, 24, 1));
    /* background-image: #0c1618,url(../../assets/物联中心/大标题.png) no-repeat; */
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    box-sizing: border-box;
    .active{
      color: #02dcd7;
    }
  }
  .titleBox {
    position: absolute;
    color: white;
    font-size: 3px;
    top: 65%;
    left: 4.6%;
    font-weight: 600;
    cursor: pointer;
    z-index: 1;
  }

  .icon{
    position: absolute;
    width: 30PX;
    height: 30PX;
    top: 57%;
    cursor: pointer;
    z-index: 1;
  }
  .left{
    left: 1.7%;
  }
  .right{
    right: 1.7%;
  }

  .tclogin {
    position: absolute;
    color: white;
    font-size: 3px;
    top: 10%;
    right: 3%;
    font-weight: 600;
    width: 5px;
    height: 5px;
    cursor: pointer;
    z-index: 1;
  }

  .tcHoutai {
    position: absolute;
    color: white;
    font-size: 3px;
    top: 10%;
    right: 9%;
    font-weight: 600;
    width: 5px;
    height: 5px;
    cursor: pointer;
    z-index: 1;
  }
  .position1 {
    left: 11.8%;
  }
  .position2 {
    left: 19%;
  }
  .position3 {
    left: 77.8%;
  }
  .position4 {
    left: 84.8%;
  }
  .position5 {
    left: 92%;
  }
  .header::after {
    position: relative;
    height: 18px;
    width: 100%;
    content: "";
    display: block;
    background: url(../../assets/物联中心/大标题.png) no-repeat;
    background-size: 100% 100%;
    background-position-y: 0;
    /* z-index: 1; */
  }
  .header::before {
    content: "西 藏 果 扎 种 畜 场 智 慧 养 殖 系 统";
    height: 18px;
    width: 100%;
    display: block;
    position: absolute;
    color: white;
    font-size: 4.2px;
    justify-content: center;
    /* align-items: center; */
    font-weight: 600;
    margin-top: 0.7%;
    z-index: 1;
  }
  .content {
    height: calc(100% - 28px);
    width: 100%;
    background-color: rgb(12, 22, 24);
    box-sizing: border-box;
  }
  .footer {
    height: 10px;
    width: 100%;
    background-color: aquamarine;
    background-image: linear-gradient(rgba(12, 22, 24, 1), rgba(12, 22, 24, 1));
    /* background: url(../../assets/物联中心/大标题底部.png) no-repeat; */
    background-size: 100% 100%;
    background-position: center;
  }
  .footer::after {
    position: relative;
    height: 10px;
    width: 100%;
    content: "";
    display: block;
    background: url(../../assets/物联中心/大标题底部.png) no-repeat;
    background-size: 100% 100%;
    background-position-y: 0;
    /* z-index: 1; */
  }
}
</style>
